import { QueryKeys, useEntity } from "@/api/core";
import { useAccountRelationship } from "@/api/relationships";
import { chatSchema } from "@/schemas";

function useChat(chatId?: string) {
  const queryInfo = useEntity({
    id: chatId!,
    queryKey: QueryKeys.chats.detail(chatId),
    enabled: !!chatId,
    endpoint: `/api/v1/pleroma/chats/${chatId}`,
    schema: chatSchema,
  });

  const { isInitialLoading } = useAccountRelationship(
    queryInfo.entity?.account?.id,
  );

  return {
    ...queryInfo,
    isLoading: isInitialLoading || queryInfo.isInitialLoading,
  };
}

export { useChat };
